import React from "react";
import MiCompAPI from "./../../util/api";
import {
  Card,
  Form,
  Row,
  Col,
  Layout,
  Select,
  Button,Icon
} from "antd";
import moment from "moment";
const { Content } = Layout;
const { Option } = Select;
class MI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      States: [],
      eff_date:[],
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentWillMount = () => {
    this.getClientMasters();
  }
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            States: data.states,
          });
        }
      },
      ["STATE"]
    );
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values, type: this.props.type});
      }
    });
  }
  changeState=(val)=>{
    this.api.invoke(
      "GetTaxProfileEffictiveDatbystate/"+val,
      "get",
      (data, success) => {
        if (success) {
          this.setState({
            eff_date: data.data,
          });
        }
      }
    );
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Content>
        <Card type="inner">
          <Row>
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
              hideRequiredMark
            >
              <Row span={24}>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">State</legend>
                      {getFieldDecorator('client_state', {
                        rules: [{ required: true, message: 'Please select State' }],
                      })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} onChange={this.changeState.bind(this)}
                        showSearch={true}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select State">
                        {this.state.States.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Effective Date </legend>
                      {getFieldDecorator('tax_eff_dt', {
                        rules: [{ required: true, message: 'Effective Date' }],
                      })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />}
                      showSearch={true}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      } className="mi_input" placeholder="Please Select Effective Date">
                      {this.state.eff_date.map(tag => <Option value={moment(tag).format("MM/DD/YYYY")} key={moment(tag).format("MM/DD/YYYY")}>{moment(tag).format("MM/DD/YYYY")}</Option>)}
                    </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={5}>
                  <Form.Item>
                    <Button htmlType="submit" type="primary">
                      Submit
                              </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Content>
    )
  }
}
const ManageTaxForm = Form.create()(MI);
export default ManageTaxForm;